export const SetSnackbar = (details) => (
        
    {

   type:"SNACKBAR_SET",
    payload:details,
    
});
